import uniqueId from 'lodash/uniqueId';
import { di } from 'react-magnetic-di';
import { fg } from '@atlaskit/platform-feature-flags';
import { getSupportedFieldConfiguration } from '../../../view-configuration';
import { calculateNextFormValue } from '../../utils/calculate-next-form-value';
/**
 * Responsible for notifying UIM store about last processed change.
 */
// Remove on 'process-change-gets-field-type-from-store' FG cleanup
export var processChangeOld = function processChangeOld(_ref) {
  var fieldId = _ref.fieldId,
    fieldValue = _ref.fieldValue,
    eventType = _ref.eventType,
    fieldType = _ref.fieldType;
  return function (_ref2, _ref3) {
    var _getSupportedFieldCon;
    var setState = _ref2.setState,
      getState = _ref2.getState;
    var viewType = _ref3.viewType;
    var emitChangeOn = (_getSupportedFieldCon = getSupportedFieldConfiguration(viewType, fieldType)) === null || _getSupportedFieldCon === void 0 ? void 0 : _getSupportedFieldCon.emitChangeOn;
    if (emitChangeOn !== eventType) {
      return;
    }
    var _getState = getState(),
      internalFormMetadata = _getState.internalFormMetadata,
      formData = _getState.formData;
    var nextFormData = calculateNextFormValue({
      internalFormMetadata: internalFormMetadata,
      formData: formData,
      fieldType: fieldType,
      fieldId: fieldId,
      fieldValue: fieldValue,
      viewType: viewType
    });
    if (nextFormData === null) {
      return;
    }

    /**
     * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
     * Otherwise, UIM app may not be notified about every single change.
     */
    setTimeout(function () {
      var changeId = uniqueId();
      setState({
        lastProcessedChange: {
          fieldId: fieldId,
          changeId: changeId
        },
        formData: nextFormData
      });
    }, 0);
  };
};

/**
 * Responsible for notifying UIM store about last processed change.
 */
export var processChangeNew = function processChangeNew(_ref4) {
  var fieldId = _ref4.fieldId,
    fieldValue = _ref4.fieldValue,
    eventType = _ref4.eventType;
  return function (_ref5, _ref6) {
    var _internalFormMetadata, _getSupportedFieldCon2;
    var setState = _ref5.setState,
      getState = _ref5.getState;
    var viewType = _ref6.viewType;
    var _getState2 = getState(),
      internalFormMetadata = _getState2.internalFormMetadata,
      formData = _getState2.formData;
    var fieldType = (_internalFormMetadata = internalFormMetadata[fieldId]) === null || _internalFormMetadata === void 0 ? void 0 : _internalFormMetadata.fieldType;
    if (!fieldType) {
      return;
    }
    var emitChangeOn = (_getSupportedFieldCon2 = getSupportedFieldConfiguration(viewType, fieldType)) === null || _getSupportedFieldCon2 === void 0 ? void 0 : _getSupportedFieldCon2.emitChangeOn;
    if (emitChangeOn !== eventType) {
      return;
    }
    var nextFormData = calculateNextFormValue({
      internalFormMetadata: internalFormMetadata,
      formData: formData,
      fieldType: fieldType,
      fieldId: fieldId,
      fieldValue: fieldValue,
      viewType: viewType
    });
    if (nextFormData === null) {
      return;
    }

    /**
     * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
     * Otherwise, UIM app may not be notified about every single change.
     */
    setTimeout(function () {
      var changeId = uniqueId();
      setState({
        lastProcessedChange: {
          fieldId: fieldId,
          changeId: changeId
        },
        formData: nextFormData
      });
    }, 0);
  };
};
export var processChange = function processChange(payload) {
  return function (storeActionApi, storeContainerProps) {
    if (fg('process-change-gets-field-type-from-store')) {
      return processChangeNew(payload)(storeActionApi, storeContainerProps);
    }
    return processChangeOld(payload)(storeActionApi, storeContainerProps);
  };
};